import React, { useEffect, useState } from "react";
import { Tabs } from "antd";
import InfoForm from "./InfoForm";
import { useDispatch, useSelector } from "react-redux";

import { ImageUpload } from "./ImageUpload";
import { getCompanyInfo } from "../../store/api/companyInfo";

const CompanyInfo = () => {
  const [loading, setLoading] = useState(false);

  const [companyInfo, setCompanyInfo] = useState(null);

  const fetchData = () => {
    getCompanyInfo()
      .then(({ data }) => {
        setCompanyInfo(data.companyInfos[0]);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    setLoading(true);
    fetchData();
  }, []);

  const renderTabContent = (infoKey) => {
    if (loading) {
      return "Loading";
    }

    const showImageUpload = [
      "introduction",
      "capitalStructure",
      "organizationStructure",
    ].includes(infoKey);

    return (
      <>
        {showImageUpload && (
          <section style={{ marginBottom: "2rem" }}>
            <h3 style={{ fontWeight: "bold" }}>Image</h3>
            <ImageUpload infoKey={infoKey} companyInfo={companyInfo} />
          </section>
        )}
        <section>
          {showImageUpload && (
            <h3 style={{ fontWeight: "bold" }}>Content</h3>
          )}
          <InfoForm
            infoKey={infoKey}
            companyInfo={companyInfo}
            refetch={() => fetchData()}
          />
        </section>
      </>
    );
  };

  const tabs = [
    {
      label: "Introduction",
      key: "1",
      children: renderTabContent("introduction"),
    },
    {
      label: "Capital Structure",
      key: "2",
      children: renderTabContent("capitalStructure"),
    },
    {
      label: "Organization Structure",
      key: "3",
      children: renderTabContent("organizationStructure"),
    },
    {
      label: "Message From Chairman",
      key: "4",
      children: renderTabContent("messageFromChairman"),
    },
    {
      label: "Message From Ceo",
      key: "5",
      children: renderTabContent("messageFromCeo"),
    },
  ];

  return (
    <div className="page-wrapper">
      <h2 style={{ fontWeight: "bold" }}>Company Info</h2>
      <Tabs defaultActiveKey="1" items={tabs}></Tabs>
    </div>
  );
};

export default CompanyInfo;
